import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";

class CustomNextArrow extends React.Component {
    constructor(props) {
        super(props);
    }

    render () {
        return(
            <CustomNextArrowContainer id="arrow" onClick={this.props.onClick}>
                <i className="fas fa-chevron-right custom-chevron-arrow"></i>
            </CustomNextArrowContainer>
        );
    }
}

export default CustomNextArrow;

const CustomNextArrowContainer = styled.div`
    display: none;
    background-color: rgba(255,255,255);
    opacity: 0;
    text-align: center;
    vertical-align: middle;
    border: 1px solid #ccc;
    height: 5rem;
    width: 3rem;
    padding-top: 1.5rem;
    position: absolute;
    top: 2.75%;
    right: 0%;
    z-index: 1;
    cursor: pointer;

    @media (min-width: 767px) {
        display: inline-block;
    } 
    @media (min-width: 940px) {
        top: 9%;
    }
    @media (min-width: 1080px) {
        top: 20%;
    }
`;

CustomNextArrow.propTypes = {
    onClick: PropTypes.func
};